import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import MirunaSpineanu from './pages/MirunaSpineanu';
import Berke from './pages/Berke';
import './styles/global.css';

function App() {
  return (
    <Router>
      <div className="MythLabs">
        <Navbar />
        <CookieConsent />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/mirunaspineanu" element={<MirunaSpineanu />} />
                <Route path="/berke" element={<Berke />} />
              </Routes>
      </div>
      <svg style={{ position: 'fixed', top: '100vh' }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="blob">
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="blob" />
          </filter>
        </defs>
      </svg>
    </Router>
  );
}

export default App;
